module.exports = __webpack_public_path__ + "img/bannerOrange.f5c38ad6.jpg";